import { UP2RENT_APP_URL } from '@rentguru/commons-utils';
import { createGraphqlClient, createGraphqlOperations } from '@up2rent/graphql';

import { getCurrentEnv } from 'src/utils/envUtils';

const ADMIN_TOOL_GRAPHQL_URL = import.meta.env.VITE_ADMIN_TOOL_GRAPHQL_URL;
const getAdminToolGraphqlUrl = (): string =>
  ADMIN_TOOL_GRAPHQL_URL ?? `https://api.admin.${getCurrentEnv()}.${UP2RENT_APP_URL}/graphql`;

export const adminToolGraphql = createGraphqlOperations(
  createGraphqlClient(getAdminToolGraphqlUrl(), { reportsAccessRevocation: false })
);
